import { inherits as _inherits, createClass as _createClass, defineProperty as _defineProperty, classCallCheck as _classCallCheck, callSuper as _callSuper, asyncToGenerator as _asyncToGenerator, regenerator as _regenerator } from '../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import PropTypes from 'prop-types';
import { Button } from './Button/index.js';
import { CancelConfirmModal } from './CancelConfirmModal/index.js';
import { i18n } from '../i18n/translate.js';
var Wizard = /*#__PURE__*/function (_React$Component) {
  function Wizard(props) {
    var _this;
    _classCallCheck(this, Wizard);
    _this = _callSuper(this, Wizard, [props]);
    _defineProperty(_this, "buildStepWizard", function () {
      _this.childSteps = [];
      var currentStep;
      React.Children.forEach(_this.props.children, function (child, i) {
        if (i === _this.state.wizardStep) {
          currentStep = /*#__PURE__*/React.cloneElement(child, {
            key: _this.state.wizardStep,
            nextStep: _this.nextStep.bind(_this),
            previousStep: _this.previousStep.bind(_this),
            ref: function ref(step) {
              _this.childSteps[i] = step;
            }
          });
        }
      });
      return currentStep;
    });
    _defineProperty(_this, "buildStepIndicator", function () {
      var numChildren = React.Children.count(_this.props.children);
      var step = 0;
      return React.Children.map(_this.props.children, function (child, i) {
        if (child.props.title) {
          step++;
          return /*#__PURE__*/React.createElement("div", {
            className: "stepindicator-child"
          }, /*#__PURE__*/React.createElement("div", {
            className: i <= _this.state.wizardStep ? 'circle complete' : 'circle'
          }, /*#__PURE__*/React.createElement("div", null, step)), /*#__PURE__*/React.createElement("div", {
            className: "stepindicatorchild-label"
          }, child.props.title), numChildren - 1 > i ? /*#__PURE__*/React.createElement("div", {
            className: "separator-bar"
          }, /*#__PURE__*/React.createElement("div", null)) : '');
        }
      });
    });
    _defineProperty(_this, "nextStep", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _this.navigateStep('goForward');
          case 1:
            return _context.a(2);
        }
      }, _callee);
    })));
    _defineProperty(_this, "previousStep", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regenerator().m(function _callee2() {
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.n) {
          case 0:
            _this.navigateStep('goBackward');
          case 1:
            return _context2.a(2);
        }
      }, _callee2);
    })));
    _defineProperty(_this, "navigateStep", /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regenerator().m(function _callee3(direction) {
        var currentStep, success, container, newStep;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              currentStep = _this.childSteps[_this.state.wizardStep];
              _this.setState({
                disableButtons: true
              });
              _context3.p = 1;
              _context3.n = 2;
              return currentStep[direction]();
            case 2:
              success = _context3.v;
              if (success) {
                if (direction === 'goBackward' && _this.state.wizardStep === 0) {
                  _this.onCancel();
                } else if (direction === 'goForward' && _this.state.wizardStep === React.Children.count(_this.props.children) - 1) {
                  if (_this.props.onComplete) {
                    _this.props.onComplete();
                  } else {
                    _this.onCancelClose(true);
                  }
                  _this.setState({
                    disableButtons: false
                  });
                } else {
                  container = _this.props.containerSelector ? document.querySelector(".".concat(_this.props.containerSelector)) : window;
                  container.scrollTo(0, 0);
                  newStep = direction === 'goBackward' ? _this.state.wizardStep - 1 : _this.state.wizardStep + 1;
                  _this.setState({
                    wizardStep: newStep,
                    disableButtons: false
                  });
                }
              } else {
                _this.setState({
                  disableButtons: false
                });
              }
              _context3.n = 4;
              break;
            case 3:
              _context3.p = 3;
              _context3.v;
              _this.setState({
                disableButtons: false
              });
            case 4:
              return _context3.a(2);
          }
        }, _callee3, null, [[1, 3]]);
      }));
      return function (_x) {
        return _ref3.apply(this, arguments);
      };
    }());
    _defineProperty(_this, "onCancel", function () {
      _this.setState({
        showCancelConfirm: true
      });
    });
    _defineProperty(_this, "onCancelClose", function (close) {
      _this.setState({
        showCancelConfirm: false
      });
      if (close) {
        _this.props.onCancel();
      } else {
        _this.setState({
          disableButtons: false
        });
      }
    });
    _defineProperty(_this, "isFinalStep", function () {
      return _this.state.wizardStep === React.Children.count(_this.props.children) - 1;
    });
    _this.state = {
      wizardStep: _this.props.initialStep || 0
    };
    return _this;
  }
  _inherits(Wizard, _React$Component);
  return _createClass(Wizard, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        _this$props$cancelBut = _this$props.cancelButtonLabel,
        cancelButtonLabel = _this$props$cancelBut === void 0 ? i18n.t('Cancel') : _this$props$cancelBut,
        _this$props$finalButt = _this$props.finalButtonLabel,
        finalButtonLabel = _this$props$finalButt === void 0 ? i18n.t('Done') : _this$props$finalButt,
        _this$props$finalButt2 = _this$props.finalButtonDataAction,
        finalButtonDataAction = _this$props$finalButt2 === void 0 ? 'final-step' : _this$props$finalButt2,
        hasButtons = _this$props.hasButtons,
        hasStepIndicator = _this$props.hasStepIndicator,
        _this$props$nextButto = _this$props.nextButtonLabel,
        nextButtonLabel = _this$props$nextButto === void 0 ? i18n.t('Next') : _this$props$nextButto,
        _this$props$previousB = _this$props.previousButtonLabel,
        previousButtonLabel = _this$props$previousB === void 0 ? i18n.t('Back') : _this$props$previousB;
      var lastButtonLabel = this.isFinalStep() ? finalButtonLabel : nextButtonLabel;
      var lastButtonDataAction = this.isFinalStep() ? finalButtonDataAction : 'next-step';
      return /*#__PURE__*/React.createElement("div", {
        className: "wizard"
      }, hasStepIndicator && React.Children.count(this.props.children) > 1 && /*#__PURE__*/React.createElement("div", {
        className: "step-indicator"
      }, this.buildStepIndicator()), /*#__PURE__*/React.createElement("div", {
        className: "step-container"
      }, this.buildStepWizard()), hasButtons && /*#__PURE__*/React.createElement("div", {
        className: "wizard-buttons"
      }, /*#__PURE__*/React.createElement("div", {
        className: "wizard-buttons-left"
      }, this.state.wizardStep > 0 && /*#__PURE__*/React.createElement(Button, {
        "data-action": "previous-step",
        icon: "angle-left",
        label: /*#__PURE__*/React.createElement("span", null, previousButtonLabel),
        onClick: this.previousStep,
        style: "secondary"
      })), /*#__PURE__*/React.createElement("div", {
        className: "wizard-buttons-right"
      }, this.props.allowCancel && /*#__PURE__*/React.createElement(Button, {
        "data-action": "cancel-wizard",
        label: /*#__PURE__*/React.createElement("span", null, cancelButtonLabel),
        onClick: this.onCancel,
        style: "secondary",
        className: "m-r-5"
      }), /*#__PURE__*/React.createElement(Button, {
        "data-action": lastButtonDataAction,
        disabled: this.props.disableNextButton || !!this.state.disableButtons,
        label: /*#__PURE__*/React.createElement("span", null, lastButtonLabel),
        onClick: this.nextStep,
        rightIcon: "angle-right",
        style: "primary"
      }))), /*#__PURE__*/React.createElement(CancelConfirmModal, {
        show: this.state.showCancelConfirm,
        onCancelClose: this.onCancelClose
      }));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      if (props.overrideSteps && props.wizardStep !== state.wizardStep) {
        return {
          wizardStep: props.wizardStep
        };
      }
      return null;
    }
  }]);
}(React.Component);
_defineProperty(Wizard, "propTypes", {
  allowCancel: PropTypes.bool,
  cancelButtonLabel: PropTypes.string,
  children: PropTypes.any,
  className: PropTypes.string,
  containerSelector: PropTypes.string,
  disableNextButton: PropTypes.bool,
  finalButtonDataAction: PropTypes.string,
  finalButtonLabel: PropTypes.string,
  hasButtons: PropTypes.bool,
  hasStepIndicator: PropTypes.bool,
  initialStep: PropTypes.number,
  nextButtonLabel: PropTypes.string,
  onCancel: PropTypes.func,
  onComplete: PropTypes.func,
  overrideSteps: PropTypes.bool,
  previousButtonLabel: PropTypes.string,
  wizardStep: PropTypes.number
});
_defineProperty(Wizard, "defaultProps", {
  allowCancel: true,
  hasButtons: true,
  hasStepIndicator: true,
  overrideSteps: false
});
Wizard.displayName = "Wizard";
export { Wizard };